export default __webpack_public_path__ + "static/phoneCall01-0e08eb1e9a4c672fd66db5cbec2f9ac8.webp";